export default {
   layout: {
        zh: '中文简体',
        en: 'English',
        kr: '한국어',
        tc:'中文繁体',
        th:'泰语ภาษาไทย',
        vn:'Việt Nam'
    },
  footer: { desc: '' },
  menu: {
    home: '홈',
    node: '노드',
    exchange: '교환',
    staking: '스테이킹',
    me: '내 계정'
  },
  home: {
    ecological: '생태 노드',
    more: '더 보기',
    genesis: '다이아몬드 노드',
    gold: '골드 노드',
    onlyLeft: '남은 수량',
    coin: '코인 비율',
    subscription: '노드 구매',
    application: '생태 응용 시나리오',
    desc1: '몰 포인트 교환 및 상품 결제',
    desc2: '노드 구독, 스테이킹 수익 및 거버넌스 투표',
    desc3: '골드 자산 교환 (RWA 매핑)',
    desc4: '상인 이익 분배 및 배당 인센티브',
    desc5: '플랫폼 수수료 정산 및 수익 분배',
    community: 'DAO 커뮤니티 거버넌스 및 투표',
    partners: '파트너',
    contact: '연락하기',
    limited: '한정 수량',
    mat: '석',
    lock: '잠금 해제',
    sky: '일'
  },
  node: {
    ecology: '생태 노드',
    meNode: '내 노드',
    genesis: '다이아몬드 노드',
    onlyLeft: '남은 수량',
    coin: '코인 비율',
    subscription: '노드 구매',
    diamond: '다이아몬드 노드',
    bronze: '브론즈 노드',
    revenue: '수익 보기',
    gold: '골드 노드',
    silver: '실버 노드',
    noNode: '노드 없음, 즉시 구독',
    totalCollection: '총 수령',
    toBeClaimed: '수령 대기',
    claimed: '수령',
    totalRelease: '총 릴리즈',
    released: '릴리즈 완료',
    toBeReleased: '릴리즈 대기',
    genesisReleased: '다이아몬드 노드 릴리즈',
    more: '아래로 당겨 더 보기',
    nodeSubscription: '노드 구독',
    receivedTo: '수령 주소',
    networkFee: '네트워크 수수료',
    confirmSubscription: '구독 확인',
    progress: '거래 진행 중',
    executionSuccessful: '실행 성공',
    at: '에서',
    view: '에서 보기',
    releaseRecord: '릴리즈 기록',
    claimRecord: '수령 기록',
    nonce: '논스',
    claimIncome: '수익 수령',
    quantityClaimed: '수령 수량',
    pickup: '수령 가능',
    all: '전체',
    confirmToReceive: '수령 확인',
    node0: '다이아몬드 노드',
    node1: '플래티넘 노드',
    node2: '골드 노드',
    node3: '에메랄드 노드',
    node4: '실버 노드',
    node5: '브론즈 노드',

           release1:'KOL 인센티브',
       release2:'글로벌 에어드롭',
       release3:'유동성 풀',
       release4:'창립팀',
       release5:'생태계 펀드',
       release6:'기관 투자자',
       release7:'글로벌 노드',
       release8:'생태계 마이닝 풀',
       release9:'스테이킹 마이닝 풀',
       

       success:'성공',
       error:'실패',
       nocount:'이 노드는 매진되었습니다'
  },
  exchange: {
    at: '에서',
    view: '에서 보기',
    more: '더 보기',
    indicator: '지표',
    market: '시장 가격 교환',
    payment: '결제',
    all: '전체',
    received: '수령',
    slippage: '슬리피지',
    minimum: '최소 수령 금액',
    cost: '네트워크 수수료',
    confirmExchange: '교환 확인',
    record: '기록',
    completed: '완료',
    error: '실패',
    downMore: '아래로 당겨 더 보기',
    price: '가격',
    progress: '거래 진행 중',
    wallet: '지갑 발급',
    refuse: '거절',
    nodeSubscription: '노드 구독',
    executionSuccessful: '실행 성공',
    nonce: '논스',
    confirm: '확인'
  },
  me: {
    assets: '총 자산',
    recharge: '충전',
    transfer: '출금',
    record: '기록'
  },
  recharge: {
    recharge: '충전',
    title: '이 주소는 NEX 관련 자산만 지원',
    address: '수령 주소',
    copy: '복사',
    share: '공유'
  },
  record: {
    record: '기록',
    all: '전체',
    recharge: '충전',
    transfer: '출금',
    claimed: '수령'
  },
  transfer: {
    transfer: '출금',
    address: '출금 주소',
    transferCoin: '전송 토큰',
    pla: '출금 주소 입력',
    network: '전송 네트워크',
    mainNetwork: '메인넷 선택',
    transferAmount: '출금 금액',
    withdraw: '최소 출금 20',
    all: '전체',
    balance: '사용 가능 잔액',
    tips: '출금 주소/네트워크 확인, 체인 등록 후 자산 복구 불가',
    amountReceived: '수령 금액',
    free: '네트워크 수수료'
  }
};